import React, {useState, useEffect} from 'react';
import axios from 'axios';
import URL from '../../config/config-server-api';
import '../configStyle_menuoption.css'
import LoadComponent from '../../utils/loadingComponent/loadingComponent';
import ComponentOption from './contanerOptions/ComponentOption';

import PaymentControUse from './paymeControlUse/paymenControlUse'
import categoryAnSubcategory from '../../utils/categoryAndSubcategory/categoryAndSubcategory';
import codePaisAndOther from '../../utils/codigosAreaPaises/codePaisAndTypemoneda.json';

import {motion} from 'framer-motion'
import moment from 'moment';

import  { format, render, cancel, register } from 'timeago.js'

import './listProducto.css'
import CreateTienda from './createTienda/createTienda';
import PageMessagePaymentControl from './paymeControlUse/pageMessagePaymentControl';

const ListaDeProductos = ({data}) => {


    const [DataTiendas, setDataTienda] = useState({

    })

    const [negocio, setNegocio] = useState({

    })

    const [updateControls, setUpdateControls] = useState({})
    const [updateControlChildren, setuUpdateControlChildren] =useState({})
    
    const [showForeEdit, setShowFormatEdit]=useState(false)
    const [srcFilelogo, setSrcFileLogo] = useState('')

    const [srcFilefotoTienda, setSrcFileFotoTienda] = useState('');

    const [fileLogo,setFileLogo] = useState('');
    const [fileFotoTienda, setFielfotoTienda] = useState('');

    const [stateFiel, setStateFile]= useState('');


    console.log('----------');

    const myRef = React.createRef();

    const ModalShow=({i})=>{
        console.log('modal show');
        myRef.current.classList.toggle("hidden") 
        setShowFormatEdit(!showForeEdit);

        // console.log(DataTiendas.negocios[i]);
        console.log({i});
        // console.log(item);
        setNegocio({
            ...DataTiendas.negocios[i]
        })

        // shanwichButtonOpne.current.classList.toggle("hidden");
    }

    const modalClosed=()=>{
        myRef.current.classList.toggle("hidden") 

    }


    useEffect(() => {
        const dUser = JSON.parse(localStorage.getItem('dataUser'))
        console.log(dUser)
        if(dUser){
            setDataTienda(dUser);
            const url = URL.UrlListNegocios+ dUser._id;

            axios.get(url)
            .then(res=>{
                console.log(res.data)
                if(res){
                    setDataTienda(
                        res.data
                    );
                }
            })
            .catch(err=>{
                // console.log(Object.keys(err))
                console.log(err?.response?.data?.error);
            })
        }


    }, [updateControls, updateControlChildren, stateFiel]);

    

    const DataTienda ={
        message: "ok",
        results: 1,
        negocios: [
            {
                categoria: "no-definido",
                state: "active",
                _id: "6021ab2ea88e5e1c086417d2",
                nombre: "compumundo",
                idClient: "6021a736a88e5e1c086417d0",
                nit: "2222222222",
                propietario: "pavel durov",
                calle: "av. murillo # 43",
                telefono: 12345678,
                description: "Tinda de tecnologia de computadoras a su alcanse, entregas a dimicilio sin recargo. ubicada en la ciudad de potosi.",
                log: 0,
                lat: 0,
                logo: "",
                fotoLugar: "",
                fechaDeRegistro: "2021-02-08T21:20:46.933Z",
               
            }
        ]
    }


    const changeState =(satate)=>{
        setuUpdateControlChildren({create:satate})
    }

    // update dataTienda
    const handleChange =(e)=>{
        console.log(e.target);
        console.log(e.target.value);

        console.log(DataTiendas.negocios[0][e.target.name])
        console.log(DataTiendas.negocios[0].nombre)

            
        setNegocio({
            ...negocio,
            [e.target.name]:e.target.value
        })
    }

    const handleCountry =(e)=>{
        e.preventDefault();
        var country = e.target.value;
        console.log(country)
        if(country!= negocio.country.slug){
          codePaisAndOther.map((d,i)=>{
              if(d.slug === country){
                var newCountry ={
                    name:d.name,
                    slug:d.slug,
                    flag: d.flag,
                    callingCodes:d.callingCodes,
                    currenciesMoneda:d.currencies[0].symbol,
                    currenciesName:d.currencies[0].name,
                    currenciesSlug:d.currencies[0].slug,

                }
                var aux = {...negocio,
                            country:newCountry,
                            callingCodes:d.callingCodes[0]
                            };
                setNegocio(
                    aux
                )
                
              }
          })
        }
        

    }

    const sendDataEdited=()=>{
        console.log('send data edidted');
        console.log(negocio);
        // setUpdateControls(negocio)
        const url = URL.UrlUpdataDataNegocio + negocio?._id;
        const newDataTienda={
                category: negocio.category,
                subcategory: negocio.subcategory,
                nombre: negocio.nombre,
                nit: negocio.nit,
                propietario: negocio.propietario,
                calle: negocio.calle,
                telefono: negocio.telefono,
                country: negocio.country,
                callingCodes:negocio.callingCodes,
                description: negocio.description,
        }

        var confing ={
            method: 'PATCH',
            url: url,
            headers:{
                'Content-Type':'application/json'
            },
            data: JSON.stringify(newDataTienda)
        }

        axios(confing)
        .then(data=>{
            console.log(data);
            sendFiles();
            setUpdateControls(negocio);  
            // setSrcFileLogo(data.logo);
            // setSrcFileFotoTienda(data.fotoLugar);
        })
        .catch(err=>{
            console.log('Error update data :' + err)
        })
        
    }

    // send file logo and foto tienda
    const sendFiles =async()=>{
        console.log(negocio)

        // send file logo tienda
        if(negocio?._id && fileLogo!=''){

            
            var formData = new FormData();
            await formData.append('image',fileLogo);

            const url = URL.UrlUploadFielLogo+ negocio._id;
            const config = {
                method:'POST',
                url:url,
                headers:{
                    'Content-Type':'application/json'
                },
                data: formData
            }

            axios(config)
            .then(res=>{
                console.log(res);
                setStateFile(res);
                setSrcFileLogo('')
            })
            .catch(err=>{
                console.log(err)
            })
            console.log(url);
        }
        
        // send file  de la tienda
        if(negocio?._id && fileFotoTienda!=''){

            
            var formData = new FormData();
            await formData.append('image',fileFotoTienda);

            const url = URL.UrlUploadFileFotoTienda + negocio._id;
            const config = {
                method:'POST',
                url:url,
                headers:{
                    'Content-Type':'application/json'
                },
                data: formData
            }

            axios(config)
            .then(res=>{
                console.log(res);
                setStateFile(res);
                setSrcFileFotoTienda('');
            })
            .catch(err=>{
                console.log(err)
            })
            console.log(url);
        }
    }


    const handleInputFile = (event)=>{
        console.log('upload file')
        console.log(event.target.files)
        const file = event.target.files[0];

        setFileLogo(file);

        let reader = new FileReader();

        // reader.readAsText(file)

        reader.onload=()=>{
            if(reader.readyState === 2){
                
                setSrcFileLogo(
                    reader.result
                )
            }
        }

        reader.readAsDataURL(file)
    } 

    // setSrcFileFotoTienda
    

    const handleInputFilefotoTienda =(e)=>{
        console.log('upload file foto tienda')
        console.log(e.target.files)
        const file = e.target.files[0];
        setFielfotoTienda(file);

        let reader = new FileReader();

        reader.onload=()=>{
            if(reader.readyState === 2){
                setSrcFileFotoTienda(
                    reader.result
                )
            }
        }

        reader.readAsDataURL(file)
    } 



    
    if(!DataTiendas.negocios){
        return(
        <ComponentOption className="p-0"> 
             <LoadComponent></LoadComponent>
        </ComponentOption>
        )
    }else
    if(DataTiendas.negocios.length==0){
        return (
            <ComponentOption>
                <CreateTienda changeState={changeState}>
                    
                </CreateTienda>
            </ComponentOption>
        )
    }else
    return (
        <div id="component-option" className="text-gray-900">
      
            <div className="container  pf-20">
                <div className="p-2 sm:p-6">
                <div> <h1 className="text-lg  sm:text-2xl font-bold uppercase pb-3">inicio </h1></div>
                <div className=" justify-end   mb-2 rounded-lg shadow-lg mx-2 sm:mx-6 ">
                   {
                        DataTiendas.negocios[0]._id?
                        <PaymentControUse idnegocio={DataTiendas.negocios[0]._id}></PaymentControUse>
                        :''
                   }
                </div>
                <div>{data}</div>
                    <section  className="px-2 sm:px-7 mb-20">

                        {


                            DataTiendas.negocios.map((d,i)=>{
                                return(

                                    <div key={i} className="bg-gray-200 rounded-2xl pl-3 mb-10 pt-3">
                                    <div className="">

                                    <header className="text-gray-700 pb-2">
                                    <div className="flex flex-row">
                                    Nombre del negocio: <h1 className="ml-2 font-bold uppercase text-green-600 ">
                                    {/* {DataTienda.negocios[0].nombre} */}
                                    {d.nombre}
                                        </h1>
                                    </div>
                                    </header>

                                    <div className="text-gray-700">NIT: <span className="text-gray-900 font-semibold"> {d.nit}</span></div>
                                    <div className="text-gray-700">Categoria: <span className="text-gray-900 font-semibold"> {d?.category.replace(/-/g,' ')}</span></div>
                                    <div className="text-gray-700">Subcategori (solo de refenrecia): <span className="text-gray-900 font-semibold"> {d?.subcategory.replace(/-/g,' ')}</span></div>
                                    <div className="text-gray-700">Estado: <span className="text-gray-900 font-semibold"> {d.state}</span></div>
                                    <div className="text-gray-700 flex flex-rows-1">Pais:  <img src={d.country.flag} alt="" className="h-5 w-8 ml-2 mr-2 my-auto rounded-lg" /> <span className="text-gray-900 font-semibold"> {d.country.name}</span></div>
                                    <div className="text-gray-700">Moneda: <span className="text-gray-900 font-semibold"> {d.country.currenciesName}</span></div>
                                    <div className="text-gray-700">Simbolo: <span className="text-gray-900 font-semibold"> {d.country.currenciesMoneda}</span></div>
                                    <div className="text-gray-700">propietario: <span className="text-gray-900 font-semibold">  {d.propietario}</span></div>
                                    <div className="text-gray-700">Dirección: <span className="text-gray-900 font-semibold">  {d.calle}</span></div>
                                    <div className="text-gray-700">Whatsapp: <span className="text-gray-900 font-semibold">+{d?.country?.callingCodes[0]}  {d?.telefono}</span></div>
                                    <div className="text-gray-700">Descripción: <span className="text-gray-900 font-semibold">  {d.description}</span></div>
                                    <div className="text-gray-700">Ubicación: 
                                    Log : <span className="text-gray-900 font-semibold ">  {d.log}</span>
                                    <span className="pl-6">Lat :</span> <span className="text-gray-900 font-semibold ">  {d.lat}</span>

                                    </div>
                                    <div className="text-gray-700">Fecha de creación:
                                     <span className="text-gray-900 font-semibold">  {format(d.fechaDeRegistro,'es_ES')}</span></div>

                                    </div>
                                    <div className="bg-gray-200 mt-2 text-gray-600">Logo de la tienda o imagenes representativa: 
                                    <div className=" h-auto w-80 rounded-lg">
                                    {
                                        d.logo!=""?
                                        <img src={d.logo} alt="" className=""/>
                                        :
                                        <svg className="bg-gray-400 h-40 w-full p-0 opacity-50" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                    }
                                    </div>
                                    </div>


                                    <div className="bg-gray-200 mt-2 mb-20 text-gray-600">Foto de la tienda o imagen los productos que ofrece: 
                                    <div className="bg-gray-400 h-auto w-80 rounded-lg">
                                    {
                                        d.fotoLugar!=""?
                                        <img src={d.fotoLugar} alt=""/>
                                        :
                                        <svg className="h-40 w-full p-0 opacity-50" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                    }
                                    </div>
                                    </div>


                                    {/* --button editar-- */}
                                    <div className=" pb-10 grid justify-items-end pr-5" >
                                        <a 
                                        onClick={()=>ModalShow({i})}
                                        href="#editDataTiendaModal"
                                        className="bg-green-600 hover:bg-green-500 py-1 rounded-xl px-6 text-white font-bold">
                                            
                                            EDITAR 
                                        </a>
                                   
                                    </div>

                                    </div>
                                )
                            })
                        }

                        {/* --modal-- edit data porduct */}
                        <div  ref={myRef} id="editDataTiendaModal" className="hidden flex items-stretch content-evenly modal-edit-data  h-screen w-screen"  >
                            
                            <motion.div key={showForeEdit} initial={{y:100, opacity:0}} animate={{y:0, opacity:1}} id="modela-content-product" className="bg-white self-center mt-10 mb-10 h-auto w-11/12 sm:w-3/4 lg:w-2/4">
                            
                                <div id="closed-modal" className="font-bold"> 
                                    <a onClick={()=>modalClosed()} className="cursor-pointer  text-gray-400 hover:text-gray-500 rounded-full">
                                        X
                                    </a> 
                                </div>
                                <div className="text-center  text-xl font-bold"> Editar datos -  Mi tienda </div>
                                <div className=" p-2 sm:p-4">
                                    <label htmlFor="Nombre del neocio" className="text-gray-400">Nombre del negocio : </label>

                                    <input type="text" className=" mb-2 border px-2 border-green-300 rounded-2xl  focus:outline-none  focus:border-green-500 focus:z-10 "
                                    name="nombre" 
                                    onChange={(e)=>handleChange(e)} 
                                    value={negocio.nombre} /> <br/>
                                    
                                  

                                    <label htmlFor="Estado" className="text-gray-400 mt-2">Nit o Lincencia de funcionamiento : </label>
                                    <input type="text" 
                                    name="nit"
                                    onChange={(e)=>handleChange(e)} 
                                    placeholder="2345678902345"
                                    className="mt-1 rounded-2xl  border px-2 border-green-300 focus:outline-none" 
                                    value={negocio.nit} /> <br/>

                                    <label htmlFor="Estado" className="my-10 text-gray-400">Estado de la tienda : </label>
                                    <span className="py-10">{negocio.state}</span> <br/>

                                    <div>
                                        <label htmlFor="Propietario" className="text-gray-400">Pais : </label> <br />
                                        <div className="flex flex-rows-1 w-full">
                                            {   negocio?.country?.flag?
                                                <img src={negocio?.country?.flag} className="w-8 h-6 rounded-lg" alt="" />
                                                :''
                                            }
                                            <select name="country" 
                                                onChange={(e)=>handleCountry(e)} 
                                                className="w-full mb-2 border  px-2 border-green-300 rounded-2xl  focus:outline-none focus:border-green-500"  id=""
                                            >
                                                <option key="country" disabled selected hidden value={negocio?.country?.slug}>{negocio?.country?.name}</option>
                                                {
                                                    codePaisAndOther.map((d,i)=>{
                                                        return  <option key={d.slug} value={d.slug}>{d.name}</option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>

                                    <label htmlFor="Telefono" className="text-gray-400">Whatsapp del vendedor: </label>
                                    <div className="flex flex-row-1  rounded-xl bg-white border border-green-300 focus:border-green-500">
                            
                                        <select onClick={(e)=>handleChange(e)} name="callingCodes" className="rounded-xl" id="">
                                            <option disabled selected hidden value={negocio?.callingCodes}>+{negocio?.callingCodes}</option>
                                            {
                                                negocio?.country?.callingCodes?
                                                negocio.country.callingCodes.map((d,i)=>{
                                                    return <option value={d}>+{d}</option>
                                                })
                                                :''
                                            }
                                        </select>
                                        <input type="text" 
                                        name="telefono"
                                        onChange={(e)=>handleChange(e)} 
                                        className=" px-2 rounded-2xl  focus:outline-none "
                                        value={negocio.telefono} /> 
                                    </div>
                                    <br/>

                                    <div>
                                        <label htmlFor="Propietario" className="text-gray-400">Categoria : </label> <br />
                                        <select name="category" 
                                            onChange={(e)=>handleChange(e)} 
                                            className="w-full mb-2 border  px-2 border-green-300 rounded-2xl  focus:outline-none focus:border-green-500"  id=""
                                        >
                                            <option key="cat" disabled selected hidden value={negocio?.category}>{negocio?.category?.replace(/-/g," ")}</option>
                                            {
                                                categoryAnSubcategory.map((d,i)=>{
                                                    return  <option key={d.slug} value={d.slug}>{d.name}</option>
                                                })
                                            }
                                        </select>
                                        <br/>
                                    </div>

                                    <div>
                                        <label htmlFor="Propietario" className="text-gray-400">Subcategoria : </label>
                                        <select name="subcategory" 
                                            onChange={(e)=>handleChange(e)} 
                                            className="w-full mb-2 border  px-2 border-green-300 rounded-2xl  focus:outline-none focus:border-green-500"  id=""
                                        >
                                            <option key="subc" disabled selected hidden value={negocio?.subcategory}>{negocio?.subcategory?.replace(/-/g," ")}</option>
                                            {
                                                categoryAnSubcategory.map((d,i)=>{
                                                    if(negocio.category === d.slug){

                                                     return d.subcategories.map((d2,i2)=>{
                                                         return <option key={d2.slug} value={d2.slug}>{d2.name}</option>
                                                     })
                                                
                                                    }
                                                    return''
                                                })
                                            }
                                        </select>
                                        <br/>
                                    </div>
                                    
                                    <label htmlFor="Propietario" className="text-gray-400">Propietario : </label>
                                    <input type="text" 
                                    name="propietario"
                                    onChange={(e)=>handleChange(e)} 
                                    className="mb-2 border  px-2 border-green-300 rounded-2xl  focus:outline-none focus:border-green-500"
                                     value={negocio.propietario} /><br/>

                                    <label htmlFor="Direccion" className="text-gray-400">Direccion : </label>
                                    <input type="text" 
                                    name="calle"
                                    onChange={(e)=>handleChange(e)} 
                                    className="mb-2 border px-2 border-green-300 rounded-2xl  focus:outline-none focus:border-green-500"
                                    value={negocio.calle} /> <br/>

                                   

                                    <label htmlFor="Descripcion" className="text-gray-400">Descripcion : </label> <br/>
                                    <textarea rows="4" cols="50" type="text" 
                                    name="description"
                                    onChange={(e)=>handleChange(e)} 
                                    className="border px-2 border-green-300 rounded-2xl pl-2 w-full  focus:outline-none focus:border-green-500"
                                    value={negocio.description} /> <br/>

                                    <label htmlFor="Ubucacion" className="text-gray-400">Ubicación : </label><br/>
                                    Log : <input type="text" onChange={(e)=>handleChange(e)}  name="log" className="border rounded-2xl pl-1 px-2 border-green-300 focus:outline-none focus:border focus:border-green-500" value={negocio.log} /> <br/>
                                    Lat : <input type="text" onChange={(e)=>handleChange(e)}  name="lat" className="border rounded-2xl pl-1 mb-3 px-2 border-green-300 focus:outline-none focus:border focus:border-green-500" value={negocio.lat} /> <br/>
                                    
                                    <label htmlFor="Fecha de creacion" className="text-gray-400">Fecha de Creación : </label>
                                    <input type="text"
                                    name="fechaDeRegistro"
                                    onChange={(e)=>handleChange(e)} 
                                     value={format(negocio.fechaDeRegistro,"es_ES")} /> <br/>

                                    {/* <label htmlFor="Logotipo">Logotipo : </label>
                                    <input className="rounded-2xl hover:bg-green-200" type="file"/><br/>

                                    <label htmlFor="Logotipo">Foto de la tienda : </label>
                                    <input className=" hover:bg-green-200" type="file"/> */}

            {/* upload file logotipo */}
            <div className="pt-4">
              <label className="block text-sm font-medium text-gray-700">
                Logotipo
              </label>
              <div style={{backgroundImage:`url(${srcFilelogo})`}} className=" mt-1 flex justify-center px-6 pt-5 pb-6 border border-gray-300 border-dashed rounded-md">
                <div className="space-y-1 text-center">
                  <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <div className="flex text-sm text-gray-600">
                    <label htmlFor="file-upload" className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                      <span>Seleccionar imagen</span>
                      <input onChange={handleInputFile} id="file-upload" name="file-upload" type="file" accept="image/*" className="sr-only"/>
                    </label>
                    <p className="pl-1">o arrastrar y soltar</p>
                  </div>
                  <p className="text-xs text-gray-500">
                    PNG, JPG, GIF maximo 10MB
                  </p>
                </div>
              </div>
            </div>
            {srcFilelogo?<img src={srcFilelogo} id="preview" alt="" width="100" height="100" />:''}
   
            
            {/* upload file foto de la tienda */}
            <div>
              <label className="block pt-4 text-sm font-medium text-gray-700">
                Foto de la tienda
              </label>
              <div style={{backgroundImage:`url(${srcFilefotoTienda})`}} className=" mt-1 flex justify-center px-6 pt-5 pb-6 border border-gray-300 border-dashed rounded-md">
                <div className="space-y-1 text-center">
                  <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <div className="flex text-sm text-gray-600">
                    <label htmlFor="file-upload-foto-tienda" className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                      <span>Seleccionar imagen de la tienda</span>
                      <input onChange={handleInputFilefotoTienda} id="file-upload-foto-tienda" accept="image/*" name="file-upload-foto-tienda" type="file" className="sr-only"/>
                    </label>
                    <p className="pl-1">o arrastrar y soltar</p>
                  </div>
                  <p className="text-xs text-gray-500">
                    PNG, JPG, GIF maximo 5MB
                  </p>
                </div>
              </div>
            </div>
            { srcFilefotoTienda?<img src={srcFilefotoTienda} id="preview-fototienda" alt="" width="100" height="100" />:''}
          
                                    
                                </div>
                                    <div id="btn-gurdar-data" className="">
                                        <motion.div whileTap={{scale:0.9}}>

                                        <button onClick={()=>sendDataEdited()} className="bg-green-500 px-10 py-1 rounded-2xl focus:outline-none text-white font-bold">
                                                GUARDAR CAMBIOS
                                        </button>
                                        </motion.div>
                                    </div>
                            </motion.div>
                        </div>
                        
                    </section>
        
                </div>

            </div>
        </div>
    );
}


export default ListaDeProductos;